<template>
  <div>
    <KpisTable :items="tableData.items" :title="tableData.title" :displayEvolution="tableData.displayEvolution"
      :downloadable="true" @download="download" :periodInfo="$t('dashboard.provenance.caption')" />
  </div>
</template>

<script>
import KpisTable from "@/components/dashboard/KPITable";

export default {
  props: {
    tableData: {
      type: Object,
      required: true
    }
  },
  components: {
    KpisTable
  },
  methods: {
    download() {
      this.$emit("download");
    }
  }
}
</script>

<style></style>